/**
 *
 * Plan Selection Modal
 *
 */
import React from 'react';
import {
  ContentWrapper,
  Text,
} from './styledComponents';
import { Link } from 'react-router-dom';
import Button from 'components/Button';
import Modal from 'components/Modal';
import H1 from 'components/H1';

const PlanSelectionModal = ({ close }) => (
  <Modal shakeOnOpen close={close} title='Plan Selection'>
    <ContentWrapper>
      <H1>
        Subscription required
      </H1>
      <Text>
        If you wish to create a new channel, you must choose a plan first. Click the button below to subscribe.
      </Text>
      <Link to={{pathname: '/memento-plan', discount: 'le'}}>
      <Button onClick={close}>select a plan </Button>
      </Link>
    </ContentWrapper>
  </Modal>
);

export default PlanSelectionModal;



// WEBPACK FOOTER //
// ./src/components/PlanSelectionModal/index.js